import { noop } from 'ui-components/default-props/noop';

import { ItemsSectionContent } from './items-section-content';
import { ItemsSectionHeaderContent } from './items-section-header-content';
import { OrdersSidebarSection } from '../orders-sidebar-section';
import { useUserSettingGroupItemsBy } from './hooks';

/**
 * @typedef {import('../../../../prop-types/intl-types.d.ts').MessageDescriptor} MessageDescriptor
 */

/**
 * @param {object} props
 * @param {object} [props.dragHandleProps]
 * @param {string[]} props.fulfillmentPlanIds
 * @param {(open: boolean) => void} [props.onClick]
 * @param {boolean} [props.open]
 * @param {(productId: string) => void} props.openProductDetailModal
 * @param {MessageDescriptor} props.sectionHeader
 * @param {number} props.totalCount
 * @param {boolean} props.willInventoryShow
 * @returns {JSX.Element}
 */
export const ItemsSection = ({
  dragHandleProps,
  fulfillmentPlanIds,
  onClick = noop,
  open = false,
  openProductDetailModal,
  sectionHeader,
  totalCount = 0,
  willInventoryShow = false,
}) => {
  const { userSettingGroupItemsBy, setUserSettingGroupItemsBy } = useUserSettingGroupItemsBy();

  const headerContent = (
    <ItemsSectionHeaderContent
      isSectionExpanded={open}
      sectionTitleMessageDescriptor={sectionHeader}
      setUserSettingGroupItemsBy={setUserSettingGroupItemsBy}
      totalCount={totalCount}
      userSettingGroupItemsBy={userSettingGroupItemsBy}
    />
  );

  const sectionContent = (
    <ItemsSectionContent
      fulfillmentPlanIds={fulfillmentPlanIds}
      openProductDetailModal={openProductDetailModal}
      totalCount={totalCount}
      userSettingGroupItemsBy={userSettingGroupItemsBy}
      willInventoryShow={willInventoryShow}
    />
  );

  return (
    <OrdersSidebarSection
      dragHandleProps={dragHandleProps}
      headerContent={headerContent}
      isExpanded={open}
      sectionContent={sectionContent}
      toggleIsExpanded={onClick}
    />
  );
};
